import React, { useState, useEffect, useContext } from 'react';
import { Card, Steps, message, Button } from 'antd';
import { ClienteStep } from './clienteStep.js';
import { ArticulosStep } from './articulosStep.js';
import { ResumenStep } from './resumenStep.js';
import { PosicionesModal } from './posicionesModal.js';
import { useMovimientos } from '../../context/movimientosContext';
import { LoginContext } from '../../context/loginContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const { Step } = Steps;

const CSalidaXArticulo = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [clientes, setClientes] = useState([]);
  const [articulosCliente, setArticulosCliente] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentArticulo, setCurrentArticulo] = useState(null);
  const [posicionesSeleccionadas, setPosicionesSeleccionadas] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { selectedCliente } = useMovimientos();
  const { user } = useContext(LoginContext);

  useEffect(() => { fetchClientes(); }, []);
  useEffect(() => { if (selectedCliente) fetchArticulosCliente(); }, [selectedCliente]); // eslint-disable-line

  const fetchClientes = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/usuarios/clientes`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      setClientes(data);
    } catch {
      message.error('Error al cargar clientes');
    }
  };

  const fetchArticulosCliente = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/movimientos/articulos/por-cliente/${selectedCliente._id}`,
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      const articulosConPosiciones = data.map(a => ({
        ...a,
        posiciones: a.posiciones || [],
        nombreArticulo: a.articulo.nombre,
        marca: a.articulo.idmarca.nombre,
        categoria: a.articulo.idcategoria.nombre,
        unidadDeMedida: a.articulo.unidadDeMedida,
        cantidadDisponible: a.cantidad,
      }));
      setArticulosCliente(articulosConPosiciones);
    } catch {
      message.error('Error al cargar artículos del cliente');
    }
  };

  const handleFinish = async (observaciones) => {
    setLoading(true);
    try {
      // construir payload por lote (si no hay, van null)
      const movimientos = selectedItems.map((art) => ({
        articulo: art.articulo._id,
        posiciones: (art.posiciones || []).flatMap(p =>
          (p.lotes || []).map(l => ({
            posicion: p.posicion,
            cantidad: Number(l.cantidadRetirar || 0),
            lote: l.lote ?? null,
            fechaVencimiento: l.fechaVencimiento ?? null,
          }))
        ).filter(x => x.cantidad > 0)
      }));

      const payload = { idUsuario: selectedCliente._id, movimientos, observaciones };

      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/movimientos/salida/multiple`,
        payload,
        { headers: { Authorization: `Bearer ${user.token}` }, responseType: 'json' }
      );

      const { pdf, numeroRemito } = data;
      const bytes = atob(pdf); const arr = new Uint8Array(bytes.length);
      for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
      const url = URL.createObjectURL(new Blob([arr], { type: 'application/pdf' }));
      const a = document.createElement('a'); a.href = url; a.download = `Remito-${numeroRemito}.pdf`;
      document.body.appendChild(a); a.click();
      setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);

      message.success('Movimientos registrados y remito descargado exitosamente');
      navigate('/posiciones');
    } catch (error) {
      console.error(error);
      if (error.response) message.error(error.response.data.message || 'Error del servidor');
      else if (error.request) message.error('No se pudo conectar con el servidor.');
      else message.error('Error al preparar la solicitud.');
    } finally {
      setLoading(false);
    }
  };

  const steps = [
    { title: 'Cliente', content: <ClienteStep clientes={clientes} /> },
    {
      title: 'Artículos y Posiciones',
      content: (
        <ArticulosStep
          articulosCliente={articulosCliente}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          setModalVisible={setModalVisible}
          setCurrentArticulo={setCurrentArticulo}
          setPosicionesSeleccionadas={setPosicionesSeleccionadas}
        />
      ),
    },
    { title: 'Resumen', content: <ResumenStep selectedItems={selectedItems} handleFinish={handleFinish} loading={loading} /> },
  ];

  return (
    <Card>
      <Steps current={currentStep} onChange={setCurrentStep}>
        {steps.map(s => <Step key={s.title} title={s.title} />)}
      </Steps>

      <div style={{ marginTop: 16 }}>{steps[currentStep].content}</div>

      <PosicionesModal
        visible={modalVisible}
        currentArticulo={currentArticulo}
        posicionesSeleccionadas={posicionesSeleccionadas}
        setPosicionesSeleccionadas={setPosicionesSeleccionadas}
        setModalVisible={setModalVisible}
        setSelectedItems={setSelectedItems}
      />

      <div style={{ marginTop: 24 }}>
        {currentStep > 0 && (
          <Button style={{ margin: '0 8px' }} onClick={() => setCurrentStep(c => c - 1)}>Anterior</Button>
        )}
        {currentStep < steps.length - 1 && (
          <Button type="primary" onClick={() => setCurrentStep(c => c + 1)}>Siguiente</Button>
        )}
      </div>
    </Card>
  );
};

export default CSalidaXArticulo;